/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

// ---------------------------------------------
// HEY, USING HUD IN THIS WAY IS PROBABLY WRONG
// the sane thing would probably be to update the world in pixi, then use that to update the HUD
// instead of updating the hud from pixi events, then listening to the hud to update the world
// ---------------------------------------------
//
// TODO - will need to resolve the "jump at end of pinch". Used to be solved at the plan-gesture-manager level.
// Can probably do better.

import { Component } from '@appCanvasCommon/component-system/Component';
import { DisplayObject } from 'pixi.js-legacy';
import Point from '@appLegacy/lib/math/Point';
import { EventBinder } from '../interaction-utils';
import { ComponentInterface } from '../../../canvas-common/interfaces/component.interface';
import { CanvasAngularLand } from 'src/app/app-data/interfaces/canvas-angular-land';
import { CONTEXT_MENUS } from 'src/app/modules/ticket-edit/context-menu.service';
import { ILoggerService } from '@touchplan/logging';
import { LoggerServiceFactory } from 'src/app/common/logging/LoggerServiceFactory';

let startCenter: any;

function actualCenter(event) {
	if (event.pointers.length === 2) {
		return {
			x: (event.pointers[1].clientX + event.pointers[0].clientX) / 2,
			y: (event.pointers[1].clientY + event.pointers[0].clientY) / 2,
		};
	}
	return false;
}
function actualDelta(event) {
	const center: any = actualCenter(event);
	return {
		deltaX: center.x - startCenter.x,
		deltaY: center.y - startCenter.y,
	};
}

export class PlanPinch extends Component implements ComponentInterface {
	private _binder: EventBinder;
	private _logger: ILoggerService;
	/**
	 * The setup method is called once all properties on a component have been decorated by the ComponentManager.
	 *
	 * From this point on, you can safely use this.getParent() and this.getManager().
	 *
	 * Arguments passed into setup are passed in via the ComponentManager.add(name, component, ...args)
	 * @param {PlanState} canvasAngularLand
	 * @param {DataContainer} CanvasAngularLand
	 */
	public override setup(canvasAngularLand: CanvasAngularLand, parent: DisplayObject): void {
		this.canvasAngularLand = canvasAngularLand;
		this._logger = LoggerServiceFactory.create('PlanPinch');
		this._binder = new EventBinder(parent);
		const hud = canvasAngularLand.hud;

		this._binder.add('hammer-pinchstart', (event) => {
			canvasAngularLand.contextMenuService.hide(CONTEXT_MENUS.TICKET_QUICK_STATUS);
			canvasAngularLand.contextMenuService.hide(CONTEXT_MENUS.TICKET_EDIT_CONFIRM_MENU);
			canvasAngularLand.timelineTicketService.closeOverflow();
			startCenter = actualCenter(event);
			hud.onStartTransform();
		});

		this._binder.add('hammer-pinch', (event) => {
			this._logger.log('hammer-pinch');
			const center = actualCenter(event);
			if (!center) {
				this._logger.log('not 2 pointers');
				return;
			}
			const delta = actualDelta(event);

			const p = new Point(delta.deltaX, delta.deltaY);
			const z = new Point(event.scale);
			const c = new Point(event.center.x, event.center.y);

			hud.onTransform(p, z, c);
		});

		this._binder.add('hammer-pinchend', (event) => {
			this._logger.log('hammer-pinchend');
			hud.onEndTransform();
		});
	}
	/**
	 * kill stuff
	 */
	public override destroy() {
		super.destroy();
		this._binder.destroy();
	}
}
